import { render, staticRenderFns } from "./applettop.vue?vue&type=template&id=a4bcdc02"
import script from "./applettop.vue?vue&type=script&lang=js"
export * from "./applettop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports